module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAVhJREFUSEvtlFFOg0AQhmdQY3sJn70GB0AeNPtUqE2lXGOvgW2MgE9r9KEcgGv47CVaozJmCUuoXWDbpm/liezO/t/Mv7ODcOQPj6wPJ0CvwztZJIQ4k4qMsd9e5SrAGMA5tzjnhTzX/O8DGQFk5jLr53R5S0TWxHdf1drBgDzPz23b/klesoCIHqUgIs78kTNXe12Qzgo04utKbGAKaQXoMoeCvBJgYWpaiRagtYVw5vvOXAonSRYQmtm1BegSj6LoQgLCMPw2hWwAVPttXGiVefNC6yQ0lfxv4RpQiyfLKSEsSo814qpjdBBAmo5H7lMTUgKICBGRhBDD1dfgAwCuADAYe86iqxXVXpxmDwAk7+dzeLm+ZoytlGZdgVqQj0lC772bN5PHpGLiOLsrsCgmvvuutEoX2h7JLuOgK3YLsM9Ak0m2nTOaRX3zZu9RcYiwOnuqoNfFP2u2DChEjsHUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/toTop.png
// module id = d4w2
// module chunks = 1